import { openWindow } from 'as-ui-kit/utils/windowManager';
import { getApiPrefix } from 'as-ui-kit/utils/stateSelectors';
import { makeDealRegex } from 'as-ui-kit/const/deals';
import { orders } from 'as-ui-kit/const/api';
import { cargoFormActions, cargoFormActionsToPathMap } from 'as-ui-kit/const/urls';

export const getAddCargoFormOpener = (loadsUrl, action, loadId) => () => {
    let url = `${loadsUrl}/${cargoFormActionsToPathMap[action]}`;

    if (action === cargoFormActions.create) {
        return window.open(url);
    }

    const query = queryString({
        id: loadId,
        isFromArchive: action === cargoFormActions.copyFromArchive ? true : null,
    });

    url = `${url}?${query}`;

    return window.open(url);
};

export const getFirmInfoUrl = (siteUrl, accountId) => `${siteUrl}/firms/${accountId}/info`;

export const getFirmInfoWindowCreator = (siteUrl, firmId) => e => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    openWindow(getFirmInfoUrl(siteUrl, firmId), {
        menubar: 'no',
        resizable: 'yes',
        scrollbars: 'yes',
        status: 'yes',
        width: 865,
        height: 800,
    });
};

export const getFirmPassportUrl = (siteUrl, accountId) => `${siteUrl}/firms/${accountId}/passport`;

export const getFirmPassportWindowCreator = (siteUrl, firmId) => () =>
    openWindow(getFirmPassportUrl(siteUrl, firmId), {
        menubar: 'no',
        resizable: 'yes',
        scrollbars: 'yes',
        status: 'yes',
        width: 865,
        height: 800,
    });

export const getRecommendationFormUrl = (siteUrl, firmId) => `${siteUrl}/Reliability/AddRecommendation.aspx?recomfor=${firmId}&WindowMode=Popup&isNewPassport=true&nr=false&fid=-1&target=-1&fortype=-1&cid=&pn=0`;

export const getRecommendationFormCreator = (siteUrl, firmId) => e => {
    e.preventDefault();
    openWindow(getRecommendationFormUrl(siteUrl, firmId), {
        menubar: 'no',
        resizable: 'no',
        width: 750,
        height: 500,
    });
};

export const getCoordinatesWindowCreator = (siteUrl, latitude, longitude) => () =>
    openWindow(siteUrl + `/Trace/GeoPoint.aspx?Action=View&Latitude=${latitude}&Longitude=${longitude}`, {
        width: 520,
        height: 600,
        menubar: 'no',
        resizable: 'yes',
        scrollbars: 'no',
        status: 'yes',
    });

export const getAuctionFaqUrl = siteUrl => `${siteUrl}/faq/Auktsiony_v_ATI.html`;

export const getLoadResponsesWindowCreator = (siteUrl, entityType, firmId, loadId, newResponsesPopup) => e => {
    e.stopPropagation();
    const params = {
        menubar: 'no',
        resizable: 'yes',
        scrollbars: 'yes',
        status: 'yes',
        width: newResponsesPopup ? 1200 : 800,
        height: newResponsesPopup ? 800 : 600,
    };

    openWindow(getLoadResponsesUrl(siteUrl, entityType, firmId, loadId, newResponsesPopup), params);
};

const getLoadResponsesUrl = (siteUrl, entityType, firmId, loadId, newResponsesPopup, source) => {
    let url = `${siteUrl}/Tables/Responses.aspx?EntityType=${entityType}&FirmId=${firmId}&ID=${loadId}&WindowMode=Popup`;

    if (newResponsesPopup) {
        url += '&resptype=counteroffer';
    }
    if (source) {
        url += `&source=${source}`;
    }
    return url;
};

const getRateOfferUrl = (siteUrl, firmId, loadId, source) => {
    const responsesUrl = getLoadResponsesUrl(siteUrl, 'Load', firmId, loadId, true, source);

    return `${responsesUrl}&PriceBtnId=${loadId}`;
};

export const openRateOfferWindow = (siteUrl, firmId, loadId, source) => {
    const params = {
        menubar: 'no',
        resizable: 'yes',
        scrollbars: 'yes',
        status: 'yes',
        width: 600,
        height: 600,
    };

    const windowUrl = getRateOfferUrl(siteUrl, firmId, loadId, source);

    openWindow(windowUrl, params);
};

export const getFixedRateLandingUrl = siteUrl => `${siteUrl}/landings/boards/udeal`;

export const addApiPrefix = (url, getState) => {
    let prefix;
    if (typeof getState === 'string') {
        prefix = getState;
    } else {
        prefix = getApiPrefix(getState);
    }

    return prefix + url;
};

export const getQueryParams = url => {
    const queryString = url.split('?')[1];
    let urlParams = {};
    if (queryString) {
        urlParams = queryString.split('&').reduce((prev, cur) => {
            const param = cur.split('=');
            return { ...prev, ...{ [param[0]]: param[1] } };
        }, {});
    }
    return urlParams;
};

export const openUDFaqWindowCreator = siteUrl => () => window.open(siteUrl + '/faq/Bezogovorochnye_sdelki.html');

export const getMakeDealFromHash = hash => {
    if (!hash) {
        return {};
    }

    const matches = hash.match(makeDealRegex);
    if (!matches || matches.length < 4) {
        return {};
    }

    const [, loadIdFromHash, dealKind, inviteContactId] = matches;
    return { loadIdFromHash, dealKind, inviteContactId };
};

export const queryString = (params = {}) =>
    Object.entries(params)
        .filter(([, value]) => value != null)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

export const fromQueryString = (query = '') =>
    query.split('&').map(kvPair => ({
        key: kvPair.substring(0, kvPair.indexOf('=')),
        value: kvPair.substring(kvPair.indexOf('=') + 1, kvPair.length),
    }));

export const getOrderFileUploaderUrl = getState => addApiPrefix(orders.files, getState);

export const getDomainFromURL = url => url?.split('/')?.[2] || null;

export const normalizedUrls = urls => urls.map(u => (u?.endsWith('/') ? u.substring(0, u.length - 1) : u));

export const normalizedUrl = url => (url?.endsWith('/') ? url.substring(0, url.length - 1) : url);
